// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bmwVw","importantInfo":"styles_importantInfo__v_jFg"};